export const getServerEnvironmentVariable = () => process.env.REACT_APP_SERVER_ENVIRONMENT || process.env.NODE_ENV
